<div class="loader" *ngIf="loading">
  <mat-spinner [diameter]="150"></mat-spinner>
</div>
<div class="card">
  <div class="container">
    <div class="background">
      <div data-test="imagem-login" class="fundo">
        <div class="fundo-content">
          <img data-test="logo-marca" class="fundo-logo" [src]="appConfig.logoUrl" [alt]="appConfig.appName">
          <h2 class="fundo-title">{{ 'signIn.tagline' | translate }}</h2>
          <p class="fundo-description">{{ 'signIn.taglineDescription' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="mobile-header">
      <h1 class="mobile-title">{{ 'signIn.welcomeTitle' | translate }}</h1>
      <p class="mobile-subtitle">{{ 'signIn.welcomeSubtitle' | translate }}</p>
    </div>

    <form *ngIf="step === 'email'" [formGroup]="emailFormGroup" class="login-form" autocomplete="off">
      <fieldset data-test="form-login" [disabled]="loading" class="fieldset">
        <h1 data-test="titulo-login" class="login-message">{{'signIn.loginMessage' | translate}}</h1>
        <mat-form-field class="full-input-grid" appearance="outline">
          <mat-label>{{ 'signUp.email' | translate }}</mat-label>
          <input #emailInput data-test="campo-email-login" type="text" inputmode="email" matInput formControlName="email"
            placeholder="Ex: example@example.com" (keydown.enter)="advance()" appLowercaseNoSpaces>
          <mat-error
            *ngIf="form['email'].invalid && form['email'].touched && form['email'].dirty && !form['email'].hasError('emailExists')">{{message.errorMessage(form['email'])}}</mat-error>
          <mat-error *ngIf="form['email'].invalid && form['email'].touched && form['email'].dirty && form['email'].hasError('emailExists')">{{
            message.emailInUse(form['email'].value)}}</mat-error>
          <mat-icon matPrefix>perm_identity_icon</mat-icon>
        </mat-form-field>
        <div class="inactive-account" *ngIf="emailNotFound">
          {{ 'signIn.emailNotFound' | translate }}
        </div>
        <div class="actions-row">
          <button data-test="btn-avancar-login" class="button" mat-raised-button color="primary" (click)="advance()">{{
            'signIn.advanceButton' | translate }}</button>
          <app-auth-secondary-action dataTest="link-criar-conta" route="/sign-up"
            [buttonLabel]="'signIn.dontHaveAccount' | translate"
            [captionLabel]="'signIn.dontHaveAccountCaption' | translate"
            [linkLabel]="'signIn.dontHaveAccountLink' | translate">
          </app-auth-secondary-action>
        </div>
      </fieldset>
    </form>

    <form *ngIf="step === 'password'" [formGroup]="passwordFormGroup" class="login-form" autocomplete="off">
      <fieldset data-test="form-senha" [disabled]="loading" class="fieldset">
        <h1 data-test="titulo-hello" class="hello-title">{{'signIn.hello' | translate}}</h1>

        <div class="email-display-simple">
          <span class="email-text">{{ email }}</span>
          <button type="button" class="link-change-account" (click)="backToEmail()" data-test="link-trocar-conta">{{
            'signIn.changeAccount' | translate }}</button>
        </div>

        <app-auth-credentials-fields [form]="passwordFormGroup" [email]="email" [mostrarOpcoes]="false"></app-auth-credentials-fields>

        <div class="forgot-password-row">
          <a class="redirect-link" routerLink="/forgot-password" data-test="link-esqueci-senha">{{
            'signIn.forgotPassword' | translate }}</a>
        </div>

        <div class="inactive-account" *ngIf="accountInactive">
          {{ inactiveMessage }}
        </div>

        <button data-test="btn-entrar" class="full-input-grid button" mat-raised-button color="primary"
          (click)="enter()">{{ 'signIn.enterButton' | translate }}</button>
      </fieldset>
    </form>

    <form *ngIf="step === 'chooseLogin'" [formGroup]="passwordFormGroup" class="login-form" autocomplete="off">
      <fieldset data-test="form-escolha-login" [disabled]="loading" class="fieldset">
        <h1 data-test="titulo-hello" class="hello-title">{{'signIn.hello' | translate}}</h1>

        <div class="email-display-simple">
          <span class="email-text">{{ email }}</span>
          <button type="button" class="link-change-account" (click)="backToEmail()" data-test="link-trocar-conta">{{
            'signIn.changeAccount' | translate }}</button>
        </div>

        <app-auth-credentials-fields [form]="passwordFormGroup" [email]="email" [mostrarOpcoes]="true"></app-auth-credentials-fields>

        <div class="forgot-password-row">
          <a class="redirect-link" routerLink="/forgot-password" data-test="link-esqueci-senha">{{
            'signIn.forgotPassword' | translate }}</a>
        </div>

        <div class="inactive-account" *ngIf="accountInactive">
          {{ inactiveMessage }}
        </div>

        <button data-test="btn-entrar" class="full-input-grid button" mat-raised-button color="primary"
          (click)="enter()">{{ 'signIn.enterButton' | translate }}</button>
      </fieldset>
    </form>
  </div>
  <span class="version">v1.18.0.0</span>
</div>